import React from 'react';
import styled from 'styled-components';
import Flex from '../Flex';
import Typo from '../Typo';
import { media } from '../../utils/media';

const Header = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 2rem;

  ${media.lessThan('phablet')} {
    flex-direction: column;
  }
`;

const PageHeader = ({ children, title }) => {
  return (
    <Header>
      {title && (
        <Flex>
          <Typo.ContentSmallHeader>{title}</Typo.ContentSmallHeader>
        </Flex>
      )}
      {children}
    </Header>
  );
};

export default PageHeader;
